import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "goldStar",
  "use": "goldStar-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 10\" id=\"goldStar\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.62237 3.90412L7.02313 0.444458L5.49117 3.78742H0.760742L4.51818 6.06537L3.2657 10L7.02313 7.75164L10.7806 10L9.52809 6.06537L13.2855 3.78742L8.62237 3.90412Z\" fill=\"#FFC400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol